// @ts-check
/**
 * @file Component: Storelocator (boot)
 *
 * Boots the engine-based store locator (`./v2`) for all traffic, including
 * Storefinder deeplinks from other pages.
 *
 * Radius behavior is switchable via URL: default = follow-on-pan; append
 * `?radiusmode=locked` to pin the radius to the searched location.
 */
import { bootStorelocatorV2 } from "./v2";

bootStorelocatorV2();
